module.exports = __webpack_public_path__ + "static/img/12areaA_11.ac8bcde.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/12areaA_11.png
// module id = 885
// module chunks = 1